module.exports = __webpack_public_path__ + "img/classic.8f10173.webp";